import React from "react";
import { Link } from "react-router-dom";
import "./Navigation.css";

import AccountBoxIcon from '@material-ui/icons/AccountBox';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import DescriptionIcon from '@material-ui/icons/Description';
import SettingsApplicationsIcon from '@material-ui/icons/SettingsApplications';
import DashboardIcon from '@material-ui/icons/Dashboard';
import DataUsageIcon from '@material-ui/icons/DataUsage';
import LocationOff from "@material-ui/icons/LocationOff";
import LocationOn from "@material-ui/icons/LocationOn";
import PeopleIcon from '@material-ui/icons/People';



export default function Navigation({
  ...props
}) {
  return (
    <nav className={"navbar-side"}>
      <ul className={"navbar-side-nav"}>

        <li className={"nav-side-item"}>
          <Link to={"/"} className={"nav-side-link"}>
            <DashboardIcon fontSize="large" />
            <span className={"link-side-text"}>Anmodninger</span>
          </Link>
        </li>

        <li className={"nav-side-item"}>
          <Link to={"/Profil"} className={"nav-side-link"}>
            <AccountBoxIcon fontSize="large" />
            <span className={"link-side-text"}>Profil</span>
          </Link>
        </li>

        <li className={"nav-side-item"}>
          <Link to={"/Dokumenter"} className={"nav-side-link"}>
            <DescriptionIcon fontSize="large" />
            <span className={"link-side-text"}>Dokumenter</span>
          </Link>
        </li>

        <li className={"nav-side-item"}>
          <Link to={"/interesseomraade"} className={"nav-side-link"}>
            <LocationOn fontSize="large" />
            <span className={"link-side-text"}>Interesseområde</span>
          </Link>
        </li>

        {props.appProps.isAdmin &&
          <>
            <li className={"nav-side-item"}>
              <Link to={"/Setup"} className={"nav-side-link"}>
                <SettingsApplicationsIcon fontSize="large" />
                <span className={"link-side-text"}>Setup</span>
              </Link>
            </li>
            <li className={"nav-side-item"}>
              <Link to={"/Monitor"} className={"nav-side-link"}>
                <DataUsageIcon fontSize="large" />
                <span className={"link-side-text"}>Monitor</span>
              </Link>
            </li>
            <li className={"nav-side-item"}>
              <Link to={"/Users"} className={"nav-side-link"}>
                <PeopleIcon fontSize="large" />
                <span className={"link-side-text"}>Brugere</span>
              </Link>
            </li>
          </>
        }

        <li className={"nav-side-item"}>
          <Link to={"/login"} className={"nav-side-link"} onClick={props.appProps.handleLogout}>
            <ExitToAppIcon fontSize="large" />
            <span className={"link-side-text"}>Log ud</span>
          </Link>
        </li>


      </ul>
    </nav>
  )
}
